import React from "react";

const numbers = ["8", "7", "6", "5", "4", "3", "2", "1"];
const letters = ["A", "B", "C", "D", "E", "F", "G", "H"];

export type CoordinatePlacement = "outside" | "inside";

type NumbersLettersProps = {
  playingWhite: boolean;
  placement?: CoordinatePlacement;
};

function coordinateColor(isLightSquare: boolean) {
  return isLightSquare
    ? "text-chess-ui-coordinate-on-light"
    : "text-chess-ui-coordinate-on-dark";
}

function InsideCoordinates({ playingWhite }: { playingWhite: boolean }) {
  const orderedNumbers = playingWhite ? numbers : [...numbers].reverse();
  const orderedLetters = playingWhite ? letters : [...letters].reverse();

  return (
    <div
      className="absolute inset-0 z-[1] pointer-events-none text-[0.6rem] font-bold leading-none md:text-[0.7rem]"
      aria-hidden="true"
    >
      <div className="absolute inset-0 grid grid-rows-8">
        {orderedNumbers.map((number, rowIndex) => (
          <div className="relative" key={number}>
            <span
              className={`absolute top-1 left-1 ${coordinateColor(
                rowIndex % 2 === 0,
              )}`}
            >
              {number}
            </span>
          </div>
        ))}
      </div>
      <div className="absolute inset-0 grid grid-cols-8">
        {orderedLetters.map((letter, columnIndex) => (
          <div className="relative" key={letter}>
            <span
              className={`absolute right-1 bottom-1 ${coordinateColor(
                columnIndex % 2 === 1,
              )}`}
            >
              {letter.toLowerCase()}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function NumbersLetters({
  playingWhite,
  placement = "outside",
}: NumbersLettersProps) {
  if (placement === "inside") {
    return <InsideCoordinates playingWhite={playingWhite} />;
  }

  const orderedNumbers = playingWhite ? numbers : [...numbers].reverse();
  const orderedLetters = playingWhite ? letters : [...letters].reverse();

  return (
    <>
      {/* Numbers (1-8) on the left side */}
      <div
        className="absolute z-[1] top-0 left-0 h-full pt-0.5 
        md:py-5 w-2 md:w-5 flex justify-center md:text-altgray-500"
      >
        <div className="grid grid-rows-8 h-full text-[0.5rem] md:text-[0.65rem] font-semibold">
          {orderedNumbers.map((num) => (
            <div key={num} className="flex items-start md:items-center">
              {num}
            </div>
          ))}
        </div>
      </div>
      {/* Letters (A-H) on the bottom */}
      <div
        className="absolute z-[1] bottom-0 -mb-[1px] left-0 pb-0 
        md:pb-0 h-3.5 md:h-5 w-full overflow-hidden md:text-altgray-500"
      >
        <div className="grid grid-cols-8 w-full h-full text-[0.5rem] md:text-[0.65rem] font-semibold md:px-5">
          {orderedLetters.map((letter) => (
            <div
              key={letter}
              className="flex justify-end items-center pr-1 md:justify-center md:pr-0"
            >
              {letter}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
